import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useEffect, useState } from 'react';
import { NetworkStatus } from '@apollo/client';
import I18n from 'I18n';
import { useAsyncBulkGenerateQuizMeMutation, useAsyncBulkGetQuizMeLazyQuery } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/QuizMeRpc.hooks';
import { checkQuizMePollingStatus, useQuizMeSession } from '../utils/quizMeUtils';
import { handleApolloErrors } from '../../../utils/errorUtils';
export const useGenerateQuizMeTrackIds = options => {
  const [asyncGenerateQuizMe, {
    loading: generateQuizTrackIdsLoading,
    error: generateQuizTrackIdsError,
    data: generateQuizTrackIds
  }] = useAsyncBulkGenerateQuizMeMutation(Object.assign({
    onError: err => handleApolloErrors({
      error: err,
      loggingTitle: 'learningCenter.interactiveEducation.errors.asyncQuizGenerationError'
    })
  }, options));
  return {
    asyncGenerateQuizMe,
    generateQuizTrackIdsLoading,
    generateQuizTrackIdsError,
    generateQuizTrackIds
  };
};
export const useAsyncGetLazyPollingQuizMe = ({
  options,
  contentIds,
  contentType
}) => {
  const [pollCount, setPollCount] = useState(0);
  const [quizMeLoading, setQuizMeLoading] = useState(false);
  const [quizMeError, setQuizMeError] = useState();
  const {
    setQuizMeStatus
  } = useQuizMeSession();
  const [getQuizMeLazy, {
    data,
    loading: queryLoading,
    error,
    stopPolling,
    networkStatus
  }] = useAsyncBulkGetQuizMeLazyQuery(Object.assign({
    notifyOnNetworkStatusChange: true,
    pollInterval: 3000,
    onError: err => {
      if (pollCount < 2) {
        setQuizMeError(err);
        handleApolloErrors({
          error: err,
          loggingTitle: 'learningCenter.interactiveEducation.errors.asyncQuizMeGetQuizError'
        });
      }
    },
    skip: isAcceptanceTest()
  }, options));
  const isPolling = networkStatus === NetworkStatus.poll || queryLoading;
  const {
    quizReady,
    retryGeneration
  } = checkQuizMePollingStatus(data, !!error);
  useEffect(() => {
    if (!quizReady && isPolling) {
      setPollCount(prev => prev + 1);
      setQuizMeLoading(true);
    }
    if (pollCount > 20 || quizReady || retryGeneration) {
      if (pollCount > 20) {
        setQuizMeError({
          message: I18n.text('learningCenter.interactiveEducation.errors.asyncQuizMeGetQuizError'),
          name: 'QuizGenerationError'
        });
      }
      stopPolling();
      setPollCount(0);
      setQuizMeLoading(false);
      setQuizMeError(undefined);
    }
    if (data) {
      data.tasks.forEach((task, index) => {
        setQuizMeStatus({
          contentType,
          contentId: contentIds[index],
          quizMeStatus: task.status
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stopPolling, data, error, isPolling]);
  return {
    getQuizMeLazy,
    queryLoading,
    quizMeLoading,
    quizMeError,
    data,
    retryGeneration
  };
};